<!--合作伙伴-->
<template>
	<div class="container">
		<div class="fei_hua">
			面向智慧交通、高速公路、普通公路、农村公路的合作伙伴招募计划，羿畅科技将多年技术沉淀全面开放共享，
			与合作伙伴一起共同打造创新、高价值、持续繁荣的生态圈，合作共赢，赋能健康、稳步发展。
			<br />
			加盟电话：13871083735
		</div>
		<section>
			<div class="title">合作伙伴服务与支持</div>
			<article class="support">
				<div class="support-panel">
					<div class="panel-item" v-for="(item,index) in supportList" :key="index">
						<div class="label">{{ item.label }}</div>
						<img :src="item.img" alt="" class="image">
						<!--移动端适配-->
						<div class="mobile-label">
							<img :src="item.mobile_img" alt="" class="mobile-image">
							{{ item.label }}
						</div>
						<p class="text">{{ item.text }}</p>
					</div>
				</div>
			</article>
		</section>
		<section>
			<div class="title">合作伙伴资格条件</div>
			<article class="criteria">
				<div class="criteria-panel">
					<div class="block">资格条件</div>
					<img class="image_1" src="@/assets/image/joinUs/icon_56.png" alt="">
					<div class="criteria-list">
						<div class="item">良好企业及法人信用记录</div>
						<div class="item">拥有一定的政府公共关系背景资源</div>
						<div class="item">具有独立法人资格，并提供相应的合法证明资料</div>
						<div class="item">拥有固定的办公场所及相关营销团队</div>
					</div>
					<img src="@/assets/image/joinUs/criteria_img.png" alt="" class="image_2">
				</div>
			</article>
		</section>
		<section class="bg_1">
			<div class="title">申请加入流程</div>
			<article class="process">
				<div class="process-panel">
					<div class="panel-item" v-for="(item,index) in processList" :key="index">
						<div class="info">
							<img :src="item.img" alt="" class="image">
							<div class="label">{{ item.label }}</div>
							<div class="text">{{ item.text }}</div>
						</div>
						<div class="line" v-if="index < processList.length - 1"></div>
					</div>
				</div>
				<!--移动端适配-->
				<div class="process-panel-mobile">
					<div class="panel-item">
						<div class="info">
							<img src="@/assets/image/joinUs/icon_57.png" alt="" class="image">
							<div class="label">申请加入</div>
							<div class="text">
								提交入驻北斗智能市场的申请意向，运营团队会在2-3个工作日进行审核并联系您。
							</div>
						</div>
					</div>
					<img src="@/assets/image/joinUs/arrow.png" alt="" class="arrow one">
					<div class="panel-item">
						<div class="info">
							<img src="@/assets/image/joinUs/icon_58.png" alt="" class="image">
							<div class="label">入驻资料提交</div>
							<div class="text">审核通过后入驻合作伙伴运营系统，提交相关资料。</div>
						</div>
					</div>
					<img src="@/assets/image/joinUs/arrow.png" alt="" class="arrow two">
					<div class="panel-item">
						<div class="info">
							<img src="@/assets/image/joinUs/icon_59.png" alt="" class="image">
							<div class="label">合作达成</div>
							<div class="text">审核通过后，通知面签合作协议。</div>
						</div>
					</div>
					<div class="panel-item">
						<div class="info">
							<img src="@/assets/image/joinUs/icon_60.png" alt="" class="image">
							<div class="label">资料审核</div>
							<div class="text">运营团队针对合伙伙伴提交的信息进行人工审核。</div>
						</div>
					</div>
					<img src="@/assets/image/joinUs/arrow.png" alt="" class="arrow three">
				</div>
			</article>
		</section>
		<section>
			<div class="title">重点合作产品</div>
			<article class="product">
				<div class="product-panel">
					<div class="panel-item" v-for="(item,index) in productList" :key="index"
						:style="{backgroundImage:`url(${item.img})`}">
						<div class="info">
							<div class="label">{{ item.label }}</div>
							<div class="text">{{ item.text }}</div>
							<div class="detail" @click="handleLink(item.page)">
								查看详情
								<i class="el-icon-right"></i>
							</div>
						</div>
						<div class="info-mobile">
							<div class="head">
								<div class="label">{{ item.label }}</div>
								<div class="detail" @click="handleLink(item.page)">
									查看详情
									<i class="el-icon-right"></i>
								</div>
							</div>
							<div class="text">{{ item.text }}</div>
							<img :src="item.img" alt="" class="image">
						</div>

					</div>
				</div>
			</article>
		</section>
	</div>
</template>

<script>
	export default {
		name: "joinUs",
		data() {
			return {
				supportList: [{
						label: '专业的营销资源支持',
						text: `罗列年度专项宣传预算，用于合作伙伴地区的市场公关、行业会议赞助、展会宣传、线上推广等活动的资金支持，
                    对于市场推展前期的宣传工具如：宣传册、视频、PPT及汇报、编写方案等提供全方位支持。`,
						img: require('@/assets/image/joinUs/icon_53.png'),
						mobile_img: require('@/assets/image/joinUs/icon_53_tra.png')
					},
					{
						label: '专业的营销资源支持',
						text: `提供全新一代的产品支持，具有功能齐全、运行流畅、操作便捷的标准化产品支持。`,
						img: require('@/assets/image/joinUs/icon_54.png'),
						mobile_img: require('@/assets/image/joinUs/icon_54_tra.png')
					}, {
						label: '专业的营销资源支持',
						text: `专业的售后运维服务团队，一对一专职人员提供即时或定期服务，持续跟进产品使用情况，
                    对于使用过程中提出的问题12小时内及时处理，24小时内抵达现场支撑。`,
						img: require('@/assets/image/joinUs/icon_55.png'),
						mobile_img: require('@/assets/image/joinUs/icon_55_tra.png')
					},
				],
				processList: [{
						label: '申请加入',
						text: `提交入驻北斗智能市场的申请意向，运营团队会在2-3个工作日进行审核并联系您。`,
						img: require('@/assets/image/joinUs/icon_57.png'),
					},
					{
						label: '入驻资料提交',
						text: `审核通过后入驻合作伙伴运营系统，提交相关资料。`,
						img: require('@/assets/image/joinUs/icon_58.png'),
					},
					{
						label: '资料审核',
						text: `运营团队针对合伙伙伴提交的信息进行人工审核。`,
						img: require('@/assets/image/joinUs/icon_59.png'),
					},
					{
						label: '合作达成',
						text: `审核通过后，通知面签合作协议。`,
						img: require('@/assets/image/joinUs/icon_60.png'),
					}
				],
				productList: [{
						label: '公路安全设施监测感知报警系统',
						page: 'highwaySafety',
						text: '公路安全设施监测感知报警系统设备适用于桥梁水毁、灾毁、滑坡、泥石流灾害...',
						img: require('@/assets/image/choiceYC/successCase/bg_07.jpg'),
					},
					{
						label: '道路AI智能养护巡查系统',
						page: 'roadAIMaintain',
						text: '道路AI智能巡检系统对巡检车进行轻量级改装后，通过车辆巡检，利用先进的AI视...',
						img: require("@/assets/image/joinUs/product_5.png")
					},
					{
						label: '高速公路视频监控AI智能监测平台',
						page: 'surveillanceAI',
						text: '随着高速公路里程和车流量的增加，传统视频监控系统已无法满足实时监测和预警...',
						img: require('@/assets/image/choiceYC/successCase/bg_08.jpg'),
					},
					{
						label: '高速公路养护管理系统',
						page: 'freewayMaintain',
						text: '高速公路养护管理平台，以“可视化驾驶舱、基础数据管理、技术状况评定、养护决策分...',
						img: require("@/assets/image/joinUs/product_1.png")
					},
					{
						label: '高速公路养护决策分析系统',
						page: 'freewayDecision',
						text: '平台关键技术包括可视化驾驶舱、基础数据管理、路产管理、桥涵构造物评价、公...',
						img: require("@/assets/image/joinUs/product_2.png")
					},
					{
						label: '普通公路养护管理系统',
						page: 'normalRoadMaintain',
						text: '普通公路巡查养护管理系统主要采用APP上报及AI智能巡检两种方式，目前由我公司...',
						img: require("@/assets/image/joinUs/product_3.png")
					},
					{
						label: '农村公路大数据云平台',
						page: 'ruralRoadBigData',
						text: '农村公路已基本形成遍布农村、连接城乡的农村公路网络，在给我们带来便捷的同时...',
						img: require("@/assets/image/joinUs/product_4.png")
					},
					{
						label: '农村公路自动化检测服务',
						page: 'ruralRoadAutoDetection',
						text: '根据交通运输部和财政部《关于进一步加强农村公路技术状况检测评定工作的通知》...',
						img: require("@/assets/image/joinUs/product_6.png")
					},
				]
			}
		},
		mounted() {},
		methods: {
			//跳转
			handleLink(page) {
				if (page) {
					this.$router.push({
						name: 'prescription'
					})
					this.$nextTick(() => this.$bus.$emit('selectSystem', page))
				}
			}
		}
	}
</script>


<style scoped lang="scss">
	.container {
		height: 100%;
		position: relative;

		.fei_hua {
			position: absolute;
			width: 660px;
			text-align: justify;
			color: #E5E5E5;
			transform: translateY(-120%) translateX(350px);
			line-height: 24px;
		}

		section {
			margin: 0 auto;

			padding-top: 100px;

			.title {
				font-size: 36px;
				text-align: center;
			}

			article {
				margin: 80px auto 0 auto;
				width: 1200px;
			}

		}

		.support {
			.support-panel {
				display: flex;
				justify-content: space-between;

				.panel-item {
					width: calc(100% / 3 - 20px);
					display: flex;
					flex-direction: column;
					align-items: center;
					border-radius: 4px;
					border: 1px solid #DCDCDC;

					.mobile-label {
						display: none;
					}

					.label {
						width: 100%;
						height: 70px;
						display: flex;
						justify-content: center;
						align-items: center;
						font-size: 24px;
						color: #FFFFFF;
						background: linear-gradient(90deg, #00FEFE 0%, #0079FE 100%);
					}

					.image {
						height: 60px;
						width: 60px;
						margin-top: 24px;
					}

					.text {
						box-sizing: border-box;
						padding: 30px;
						font-size: 16px;
						text-align: justify;
						line-height: 32px;
					}
				}
			}
		}

		.criteria {
			padding-bottom: 80px;

			.criteria-panel {
				display: flex;
				align-items: center;

				.block {
					width: 150px;
					height: 60px;
					background: #0079FE;
					color: #FFFFFF;
					border-radius: 4px;
					font-size: 24px;
					display: flex;
					justify-content: center;
					align-items: center;
				}

				.image_1 {
					height: 216px;
				}


				.criteria-list {
					margin-left: 20px;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					height: 276px;

					.item {
						width: 480px;
						display: flex;
						align-items: center;
						background: #E5F1FF;
						border-radius: 4px;
						padding: 15px 30px;
						font-size: 20px;
					}
				}


				.image_2 {
					margin-left: 40px;
					height: 300px;
					width: 320px;
				}
			}
		}

		.bg_1 {
			background-image: url("~@/assets/image/joinUs/process_bg.png");
			background-size: 100% 100%;
			background-repeat: no-repeat;

			.title {
				color: #FFFFFF;
			}
		}

		.process {
			padding-bottom: 80px;

			.process-panel-mobile {
				display: none;
			}

			.process-panel {
				display: flex;
				justify-content: space-between;

				.panel-item {
					color: #FFFFFF;
					display: flex;
					text-align: center;

					.info {
						width: 14rem;

						.image {
							width: 126px;
							height: 126px;
						}

						.label {
							margin-top: 30px;
							font-size: 24px;
							font-weight: bold;
						}

						.text {
							margin-top: 24px;
							font-size: 16px;
							text-align: justify;
							line-height: 32px;
						}

					}


					.line {
						margin-top: 50px;
						width: 100px;
						height: 2px;
						background: rgba(255, 255, 255, 0.5);
						border-radius: 92px;
					}
				}
			}
		}

		.product {
			padding-bottom: 80px;

			.product-panel {
				display: grid;
				grid-template-rows: repeat(2, 290px);
				grid-template-columns: repeat(3, 380px);
				grid-gap: 30px;

				.panel-item {
					height: 100%;
					background-size: 100% 100%;
					overflow: hidden;

					&:hover {
						.info {
							margin-top: 0;
							background: linear-gradient(90deg, rgba(0, 254, 254, 0.8) 0%, rgba(0, 121, 254, 0.8) 100%);
						}
					}

					.info-mobile {
						display: none;
					}

					.info {
						box-sizing: border-box;
						padding: 24px;
						color: #FFFFFF;
						margin-top: 45%;
						background: rgba(0, 0, 0, .5);
						height: 100%;
						transition: all 0.3s;

						.label {
							font-size: 20px;
							font-weight: bold;
						}

						.text {
							margin-top: 14px;
							font-size: 16px;
							line-height: 24px;
						}

						.detail {
							cursor: pointer;
							font-size: 18px;
							margin-top: 50px;

							&:active {
								color: #1890FF;
							}
						}
					}
				}
			}
		}
	}

	@import "./style.scss";
</style>